"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.environmentAbbreviationNames = void 0;
var environmentAbbreviationNames;
(function (environmentAbbreviationNames) {
    environmentAbbreviationNames["TEST"] = "test";
    environmentAbbreviationNames["DEVELOP"] = "dev";
    environmentAbbreviationNames["STAGING"] = "stg";
    environmentAbbreviationNames["PROD_US"] = "prod-us";
    environmentAbbreviationNames["PROD_UK"] = "prod-uk";
    // Support event-sink us queue name
    // Should be declared as the last value in the enum so that prod-us and prod-uk could be matched first by the regex
    environmentAbbreviationNames["PROD"] = "prod";
})(environmentAbbreviationNames || (exports.environmentAbbreviationNames = environmentAbbreviationNames = {}));
